import _extends from '@babel/runtime/helpers/extends';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default from 'react';
import './Radio.scss.js';
import { classnames } from '../../../utils/classnames.js';

var Radio = function Radio(_a) {
  var label = _a.label,
      value = _a.value,
      _a$icon = _a.icon,
      icon = _a$icon === void 0 ? true : _a$icon;
      _a.align;
      var _a$fullWidth = _a.fullWidth,
      fullWidth = _a$fullWidth === void 0 ? true : _a$fullWidth,
      props = __rest(_a, ["label", "value", "icon", "align", "fullWidth"]);

  return /*#__PURE__*/React__default.createElement("label", {
    className: classnames('rf-radio', props.className, props.disabled && 'disabled', fullWidth && 'rf-radio--fullwidth', 'rf-radio--align'),
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("input", _extends({}, props, {
    type: "radio",
    className: "rf-radio__input",
    value: value,
    "data-v-6e52f9c7": ""
  })), !!icon && /*#__PURE__*/React__default.createElement("span", {
    className: "rf-radio__circle",
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "rf-radio__mark",
    "data-v-6e52f9c7": ""
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "rf-radio__label",
    "data-v-6e52f9c7": ""
  }, label));
};

export { Radio as default };
